<div [hidden]="false" id="score-graph"></div>